import { render, staticRenderFns } from "./PdfUploader.vue?vue&type=template&id=38d3aec3"
import script from "./PdfUploader.vue?vue&type=script&lang=js"
export * from "./PdfUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports